import React from "react";
import { MessageCircle, ArrowUpRight, QrCode } from "lucide-react";
const QR="https://customer-assets.emergentagent.com/job_digital-identity-120/artifacts/wihck0u8_JPEG%20image-45CF-93D0-20-0.jpeg";
export default function WhatsAppChannelCard({variant="default",className=""}) {
 return <section data-testid="whatsapp-channel-card" className={"icaard-channel-card "+className}>
  <div className="icaard-channel-icon"><MessageCircle size={24}/></div>
  <div className="icaard-channel-eyebrow">STAY CONNECTED</div>
  <h2>More from iCaard.</h2>
  <p>Fresh updates, new places and experiences. Follow our WhatsApp channel to stay in the loop.</p>
  <div className="icaard-channel-tags"><span>New features</span><span>Events</span><span>Our community</span></div>
  <a href="https://whatsapp.com/channel/icaard" target="_blank" rel="noopener noreferrer" data-testid="whatsapp-channel-open-btn" className="icaard-channel-link">Follow on WhatsApp <ArrowUpRight size={17}/></a>
  <details className="icaard-channel-code"><summary><QrCode size={15}/> Prefer to scan? <span>Show QR code</span></summary><img src={QR} alt="Scan to follow iCaard on WhatsApp" data-testid="whatsapp-channel-qr" loading="lazy"/></details>
 </section>;
}
